import React, { useState } from 'react';
import { signInWithGoogle, isPopupCancelledError } from '../utils/googleSignIn';
import { getAuthErrorMessage } from '../utils/authErrorMessage';

interface GoogleSignInButtonProps {
  label: string;
  onSuccess: () => void;
  onError: (message: string) => void;
}

const GoogleSignInButton: React.FC<GoogleSignInButtonProps> = ({
  label,
  onSuccess,
  onError,
}) => {
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    // A stale error from the email form would otherwise survive a silent
    // popup-cancel and read as if Google sign-in had failed.
    onError('');
    setLoading(true);
    try {
      await signInWithGoogle();
      onSuccess();
    } catch (err: unknown) {
      if (!isPopupCancelledError(err)) {
        onError(
          getAuthErrorMessage(
            err,
            'Nie udało się zalogować przez Google. Spróbuj ponownie.'
          )
        );
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={loading}
      className="w-full flex items-center justify-center gap-3 bg-white border border-gray-300 hover:bg-gray-50 disabled:bg-gray-100 disabled:cursor-not-allowed text-gray-700 text-base font-medium py-2.5 px-6 rounded-lg transition duration-200 focus:outline-none focus:ring-2 focus:ring-orange-600 focus:ring-offset-2"
    >
      <svg className="h-5 w-5" viewBox="0 0 48 48" aria-hidden="true">
        <path
          fill="#EA4335"
          d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"
        />
        <path
          fill="#4285F4"
          d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"
        />
        <path
          fill="#FBBC05"
          d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"
        />
        <path
          fill="#34A853"
          d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"
        />
      </svg>
      {loading ? 'Logowanie...' : label}
    </button>
  );
};

export default GoogleSignInButton;
